/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
Shopify.theme.jsCart = {
  init: function ($section) {
    this.$section = $section;

    // Prevent submit on Enter in qty inputs
    $('#cart_form').keydown(function (e) {
      if (e.keyCode === 13) { e.preventDefault(); return false; }
    });

    // inside init(), initial hooks:
    $(document).on('cart:updated cart:refresh', function(){
    });

    $.getJSON('/cart.js', function(c){
    });

    $(document).on('click', '[data-cart-page-delete]', function (e) {
      e.preventDefault();
      const lineIndex = Number($(this).data('line-item-key'));
      Shopify.theme.jsCart.removeFromCart(lineIndex);
      return false;
    });
  },

  removeFromCart: function (lineID) {
    const $cartItem = Shopify.theme.jsCart.$section.find(`[data-line-item="${lineID}"]`);

    // show loader
    (function showCartPageLoader(){
      if ($('#mm-loader-page').length) return;
      const ensureLoaderStyle = () => {
        if ($('#mm-loader-style').length) return;
        $('head').append(`<style id="mm-loader-style">
          .mm-loader{position:absolute;inset:0;background:rgba(255,255,255,.6);display:flex;align-items:center;justify-content:center;z-index:99999}
          .mm-spinner{width:42px;height:42px;border:3px solid rgba(0,0,0,.2);border-top-color:rgba(0,0,0,.7);border-radius:50%;animation:mmspin 1s linear infinite}
          @keyframes mmspin{to{transform:rotate(360deg)}}
        </style>`);
      };
      ensureLoaderStyle();
      const container = document.querySelector('.cart__form') || document.querySelector('.cart') || document.body;
      if (getComputedStyle(container).position === 'static') { container.setAttribute('data-mm-pos','set'); container.style.position='relative'; }
      const overlay = document.createElement('div');
      overlay.id='mm-loader-page'; overlay.className='mm-loader'; overlay.innerHTML = `<div class="mm-spinner" role="progressbar" aria-label="Loading"></div>`;
      container.appendChild(overlay);
    })();

    window.__mg_suppress_refresh = true;
    if ($cartItem.length) $cartItem.css('opacity', '0.5');

    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: 'quantity=0&line=' + lineID,
      dataType: 'json',
      success: function (cart) {
        // Remove the node quickly to avoid flicker
        if ($cartItem.length) {
          $cartItem.addClass('animated zoomOut');
          $cartItem.remove();
        }

        Shopify.theme.jsCart.updateView(cart, lineID);

        if (typeof Shopify.theme.jsAjaxCart !== 'undefined') {
          Shopify.theme.jsAjaxCart.updateView();
        }
        $(document).trigger('cart:updated');
      },
      complete: function () {
        $('#mm-loader-page').remove();
        const p = document.querySelector('[data-mm-pos="set"]');
        if (p){ p.style.position=''; p.removeAttribute('data-mm-pos'); }
        window.__mg_suppress_refresh = false;
      }
    });
  },

  updateView: function (cart, lineID) {
    const haveCart = cart && typeof cart === 'object';

    $.ajax({
      dataType: 'html',
      url: '/cart',
      success: function (html) {
        if (lineID != null) {
          const updatedItems = $(html).find('.cart__item-list .cart__card');
          const currentItems = $('.cart__item-list .cart__card');

          if (updatedItems.length !== currentItems.length) {
            const updatedCartList = $(html).find('.cart__item-list');
            $('.cart__item-list').replaceWith(updatedCartList);
          }

          $('.cart__item-list .cart__card').each(function (idx, el) {
            $(el).attr('data-line-item', (idx + 1));
            $(el).find('[data-line-item-key]').attr('data-line-item-key', (idx + 1));
          });

          const $newTotal = $(html).find(`[data-line-item="${lineID}"] .cart__total`);
          const $newQty   = $(html).find(`[data-line-item="${lineID}"] .quantity-input`);
          const $newPrice = $(html).find(`[data-line-item="${lineID}"] .cart__price`);
          if ($newTotal.length) $(`[data-line-item="${lineID}"] .cart__total`).replaceWith($newTotal);
          if ($newQty.length)   $(`[data-line-item="${lineID}"] .quantity-input`).replaceWith($newQty);
          if ($newPrice.length) $(`[data-line-item="${lineID}"] .cart__price`).replaceWith($newPrice);
        }

        const $footer = $(html).find('.cart__footer');
        if ($footer.length) $('.cart__footer').replaceWith($footer);

        if (haveCart ? cart.item_count > 0 : $(html).find('.cart__card').length > 0) {
          $('.cart__empty-cart-message').addClass('is-hidden');
          $('.cart__form').removeClass('is-hidden');
        } else {
          $('.cart__empty-cart-message').removeClass('is-hidden');
          $('.cart__form').addClass('is-hidden');
        }

        if (haveCart) {
          $('[data-bind="itemCount"]').text(cart.item_count);
        } else {
          (window.CartState?.read() || $.getJSON('/cart.js')).then(function(c){
            try { $('[data-bind="itemCount"]').text(c.item_count); } catch(e){}
          });
        }

        try { $(document).trigger('cart:updated'); } catch(e){}
        try { document.dispatchEvent(new CustomEvent('cart:refresh')); } catch(e){}
      }
    });
  },

  unload: function () {
    $('[data-cart-page-delete]').off();
    $('#cart_form').off();
  }
};
/******/ })();
